import APIClient from './index';
import _ from 'lodash';

export const getAllDepartments = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('Departments')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
